(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["korevani-hero-shelf"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var main = document.getElementById('hero-product-main');
    var thumbs = document.querySelectorAll('.hero-product__thumb');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (main) {
          main.removeAttribute('srcset');
          main.src = thumb.getAttribute('data-full');
        }
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    var select = document.getElementById('hero-product-variant');
    var priceValue = document.getElementById('hero-product-price-value');
    if (select && priceValue) {
      select.addEventListener('change', function () {
        var option = select.options[select.selectedIndex];
        priceValue.textContent = option.getAttribute('data-price');
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
